import { computed } from 'vue';
import { useRoute } from 'vue-router';

import useBackRoute from '@/composables/useBackRoute';
import useBackState, { backStateRevision } from '@/composables/useBackState';
import { shouldShowBackButton } from '@/utils/backButtonRules';

export default function useBackButton() {
    const route = useRoute();
    const { goBack } = useBackRoute();
    const { getState } = useBackState();

    const showBackButton = computed(() => (
        shouldShowBackButton(route, getState(), backStateRevision.value)
    ));

    return {
        goBack,
        showBackButton,
    };
}
